import styled from 'styled-components'

const StyledTable = styled.table` 
  td,
  th {
    border: 1px solid #cccccc;
  } 
  td {
    padding: 5px 10px;
    font-size: 13px;
  }

  tbody tr {
    :nth-of-type(odd) {
      background-color: #efefef;
    }
    :hover {
      background-color: #f2d5de;
    }
  }
  thead > tr {
    background-color: #c2c2c2;
  }  
`;

export { StyledTable };
